export default {
  __MENU_LIST__(state, n) {
    state[n.key] = n.val
  },
  __USER_MENU_LIST__(state, n) {
    state[n.key] = n.val
  },
  __TABLE_HEIGHT__(state, n) {
    state[n.key] = n.val
  },
  __APP_CONFIG__(state, n) {
    state[n.key] = n.val
  },
  __APP_LOADING__(state, n) {
    state[n.key] = n.val
  },
  __PAGE_OPT__(state, n) {
    state[n.key] = n.val
  },
  __HOUSE_TREE__(state, n) {
    ERP.setLocalStore(n.key,n.val)
    state[n.key] = n.val
  },
  __HOUSE_TREE_OPEN__(state, n) {
    ERP.setLocalStore(n.key,n.val)
    state[n.key] = n.val
  },
  __HOUSE_TREE_LIST__(state, n) {
    ERP.setLocalStore(n.key,n.val)
    state[n.key] = n.val
  },
  user_permission_ids(state, n) {
    state[n.key] = n.val
  },
  APP_TOKEN(state, n) {
    window.localStorage.setItem('token',n.val)
    state[n.key] = n.val
  },
  APP_LOGIN_NAME(state, n) {
    window.localStorage.setItem('login',n.val)
    state[n.key] = n.val
  },
  excelTaskAdd(state) {
    state.excelTaskCount++;
  },
  excelTaskClear(state) {
    state.excelTaskCount = 0;
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js